import client from '../utils/api'
import { createSlice } from '@reduxjs/toolkit'
import { createApiAction } from '../utils/redux-tool'

const name = 'widget'

const initialState = {
  list: null,
  data: {},
  loading: {},
  error: {},
}

export const getWidgets = createApiAction('widget/list', client.search('/api/session/widget/list'))

export const runWidget = createApiAction('widget/run', client.search('/api/session/widget/run/:type'))

export const saveWidgetPerson = createApiAction('widget/person/save', client.create('/api/session/widget/person/create'))

const codeOf = action => action.meta.arg.code

const sessionSlice = createSlice({
  name,
  initialState,
  reducers: {
    clearWidgetData: state => {
      state.data = {}
      state.loading = {}
      state.error = {}
    },
  },
  extraReducers(builder) {
    builder
      .addCase(getWidgets.fulfilled, (state, action) => {
        state.list = action.payload
      })
      .addCase(runWidget.pending, (state, action) => {
        state.loading[codeOf(action)] = true
        delete state.error[codeOf(action)]
      })
      .addCase(runWidget.fulfilled, (state, action) => {
        state.data[codeOf(action)] = action.payload
        state.loading[codeOf(action)] = false
      })
      .addCase(runWidget.rejected, (state, action) => {
        state.loading[codeOf(action)] = false
        state.error[codeOf(action)] = action.error?.message ?? 'Failed to load widget'
        state.data[codeOf(action)] = null
      })
      .addCase(saveWidgetPerson.fulfilled, (state, action) => {
        const saved = action.payload
        state.list = state.list?.map(widget =>
          Number(widget.id) === Number(saved.widgetId) ? { ...widget, widgetPerson: [saved] } : widget,
        )
      })
  },
})

export const { clearWidgetData } = sessionSlice.actions

export default sessionSlice.reducer
